<template>
  <div class="app-container">
    <div>
      <div style="padding: 10px">
        <el-button type="primary" style="margin-left: 4px" @click="newAdd">新增</el-button>

        <el-button type="primary" :disabled="Status === 2" style="margin-left: 4px" @click="save">保存</el-button>
        <el-button type="primary" :disabled="isSave" @click.native="orderReview">{{ ReviewName }}</el-button>

        <div class="text-box">制单人：{{ MakeEmpName }}</div>
        <div class="text-box">审核人：{{ ReviewEmpName }}</div>
      </div>

      <el-table border key="table1" class="table_bottom table-line tb-c-head" :data="tableData" stripe style="margin-top: 18px" ref="table1">
        <el-table-column label="存货编码" prop="ProductNo" align="center" min-width="180"> </el-table-column>
        <el-table-column label="存货名称" align="center" min-width="120" prop="ProductName">
          <template slot-scope="{ row }">
            <span class="not-edit" v-if="Status === 2">{{ row.ProductName }}</span>
            <account-select
              v-else
              v-model="row.ProductName"
              :source="DAccount"
              @select="onSelect($event, row)"
              @inputText="inputText"
              @click.native="resetFun"
              @currentPage="currentPage"
              :pageType="true"
              :pageSize="pageParams.pageSize"
              :pageIndex="pageParams.pageIndex"
              :listTotal="initTotal"
            />
          </template>
        </el-table-column>
        <el-table-column label="规格型号" prop="ProductSpec" align="center" min-width="100"> </el-table-column>
        <el-table-column label="单位" prop="UnitId" align="center" min-width="100">
          <template slot-scope="{ row }">
            <el-select v-model="row.UnitId" v-if="Status === 0 && row.Units.length !== 0">
              <el-option v-for="item in row.Units" :key="item.UnitId" :label="item.UnitName" :value="item.UnitId"></el-option>
            </el-select>
            <span v-else>{{ row.UnitName }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="PropertyId" label="属性" min-width="100">
            <template slot-scope="{ row }">
              <el-select v-model="row.PropertyId" @change="changeProperty($event, row)"  v-if="Status === 0 &&row.UseProcess">
                <el-option v-for="item in propertyList" :key="item.PropertyId" :value="item.PropertyId" :label="item.PropertyName"></el-option>
              </el-select>
            <span v-else>{{ row.PropertyName }}</span>
            </template>
          </el-table-column>
        <el-table-column label="颜色" prop="ColorId" align="center" min-width="100">
          <template slot-scope="{ row }">
            <el-select v-model="row.ColorId" @change="changeColor($event,row)" v-if="Status === 0 &&row.UseColor">
              <el-option v-for="item in row.Colors" :key="item.ColorId" :label="item.ColorName" :value="item.ColorId"></el-option>
            </el-select>
            <span v-else>{{ row.ColorName }}</span>
          </template>
        </el-table-column>      
          <el-table-column label="存货条码" prop="BarCode" align="center" min-width="100"> </el-table-column>
        <el-table-column label="数量" prop="Quantity" align="center" min-width="100">
          <template slot-scope="{ row }">
            <el-input v-model="row.Quantity" placeholder="请输入数量" v-if="Status === 0" />
            <span v-else>{{ row.Quantity }}</span>
          </template>
        </el-table-column>
        <el-table-column label="图片" prop="ImgUrl" align="center" min-width="100">
          <template slot-scope="{ row }">
            <el-button type="text" @click="viewImg(row)">{{ row.ProductId ? '查看' : '' }} </el-button>
          </template>
        </el-table-column>
        <el-table-column label="加工阶段" prop="ProcessStage" align="center" min-width="100">
          <template slot-scope="{ row }">
            <span>{{ getStage(row.ProcessStage) }}</span>
            <!-- <span>{{
              (() => {
                if (row.ProcessStage === 4) {
                  return '组合'
                } else if (row.ProcessStage === 3) {
                  return '装配'
                } else if (row.ProcessStage === 1) {
                  return '注塑'
                } else if (row.ProcessStage === 2) {
                  return '配件'
                } else if (row.ProcessStage === 0) {
                  return '无'
                }
              })()
            }}</span> -->
          </template>
        </el-table-column>
        <el-table-column label="存货类型" prop="ProduceTypeName" align="center" min-width="100"> </el-table-column>
        <el-table-column label="bom版本" prop="BomNo" align="center" min-width="120">
          <template slot-scope="{ row }">
            <el-input v-model="row.BomNo" placeholder="请输入版本号" v-if="Status === 0" />
            <span v-else>{{ row.BomNo }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="WarehouseId" label="预入仓" min-width="120">
          <template slot-scope="{ row }">
            <el-select v-model="row.WarehouseId" @change="change(row)">
              <el-option v-for="item in warehouseList" :key="item.WarehouseId" :label="item.WarehouseName" :value="item.WarehouseId"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="成品率%" prop="Yieldrate" align="center" min-width="120">
          <template slot-scope="{ row }">
            <el-input v-model="row.Yieldrate" placeholder="请输入成品率" v-if="Status === 0" />
            <span v-else>{{ row.Yieldrate }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column
            label="生产类型"
            prop="ProductionType"
            align="center"
            min-width="100"
          >
          <template slot-scope="{ row }">
              <el-select v-model="row.ProductionType"  v-if="Status === 0">
                <el-option key="ProductionType1" label="自产" :value="0"></el-option>
                <el-option key="ProductionType2" label="委外" :value="1"></el-option>
                <el-option key="ProductionType3" label="自产&委外" :value="2"></el-option>
              </el-select>
              <span v-else>{{row.ProductionType === 0 ? '自产' : row.ProductionType === 1 ? '委外' : '自产&委外'}}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="外协供应商编码"
            prop="ProductionDpNo"
            align="center"
            min-width="120"
          >
          </el-table-column>
          <el-table-column
            label="外协供应商名称"
            prop="ProductionDpId"
            align="center"
            min-width="120"
          >
          <template slot-scope="{ row }">
              <el-select v-model="row.ProductionDpId " v-if="Status === 0"  @change="changeProductionDp($event, row)"  :disabled="Status === 1 || row.ProductionType !== 1">
                <el-option v-for="item in tradeUnitList" :key="item.TradeUnitId" :label="item.FullName" :value="item.TradeUnitId"></el-option>
              </el-select>
              <span v-else>{{row.PropertyName}}</span>
            </template>
          </el-table-column> -->
        <el-table-column label="默认BOM" prop="IsDefault" align="center" min-width="100">
          <template slot-scope="{ row }">
            <el-select v-model="row.IsDefault" v-if="Status === 0">
              <el-option key="IsDefault1" label="是" :value="true"></el-option>
              <el-option key="IsDefault2" label="否" :value="false"></el-option>
            </el-select>
            <span v-else>{{ row.IsDefault ? '是' : '否' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="设计图" prop="TeImgs" align="center" min-width="100">
          <template slot-scope="{ row }">
            <el-button v-if="Status === 0" type="text" @click="uploadImg(row)">上传</el-button>
            <el-button v-else type="text" @click="viewImg2(row)">{{ row.TeImgs.length > 0 ? '查看' : '' }} </el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-tabs tab-position="top" class="tabs" type="card" @tab-click="tabClick">
        <el-tab-pane>
          <div slot="label">加工产品子件</div>

          <el-table border key="table2" class="table_bottom table-line tb-c-head" :data="child" stripe style="margin-top: 18px" ref="table2" @row-click="addColumn" :row-class-name="tableRowClassName">
            <el-table-column label="子件编码" prop="ProductNo" align="center" min-width="180"> </el-table-column>
            <el-table-column label="子件名称" align="center" min-width="120" prop="ProductName">
              <template slot-scope="{ row }">
                <span class="not-edit" v-if="Status === 2">{{ row.ProductName }}</span>
                <account-select
                  v-else
                  v-model="row.ProductName"
                  :source="child_DAccount"
                  @select="onSelect($event, row, 1)"
                  @inputText="inputTextChild"
                  @click.native="resetChildFun"
                  @currentPage="currentChildPage"
                  :pageType="true"
                  :pageSize="child_pageParams.pageSize"
                  :pageIndex="child_pageParams.pageIndex"
                  :listTotal="child_initTotal"
                />
              </template>
            </el-table-column>
            <el-table-column label="规格型号" prop="ProductSpec" align="center" min-width="100"> </el-table-column>
            <el-table-column label="单位" prop="UnitId" align="center" min-width="100">
              <template slot-scope="{ row }">
                <el-select v-model="row.UnitId" v-if="Status === 0 && row.Units.length !== 0">
                  <el-option v-for="item in row.Units" :key="item.UnitId" :label="item.UnitName" :value="item.UnitId"></el-option>
                </el-select>
                <span v-else>{{ row.UnitName }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="PropertyId" label="属性" min-width="100">
            <template slot-scope="{ row }">
              <el-select v-model="row.PropertyId" @change="changeProperty($event, row)"  v-if="Status === 0 &&row.UseProcess">
                <el-option v-for="item in propertyList" :key="item.PropertyId" :value="item.PropertyId" :label="item.PropertyName"></el-option>
              </el-select>
            <span v-else>{{ row.PropertyName }}</span>
            </template>
          </el-table-column>
            <el-table-column label="颜色" prop="ColorId" align="center" min-width="100">
              <template slot-scope="{ row }">
                <el-select v-model="row.ColorId" @change="changeColor($event,row)" v-if="Status === 0 && row.UseColor">
                  <el-option v-for="item in row.Colors" :key="item.ColorId" :label="item.ColorName" :value="item.ColorId"></el-option>
                </el-select>
                <span v-else>{{ row.ColorName }}</span>
              </template>
            </el-table-column>
          <el-table-column label="存货条码" prop="BarCode" align="center" min-width="100"> </el-table-column>
            <el-table-column label="数量" prop="Quantity" align="center" min-width="100">
              <template slot-scope="{ row, $index }">
                <el-input v-model="row.Quantity" @input="changeQuantity($event, row, $index)" placeholder="请输入数量" v-if="Status === 0" />
                <span v-else>{{ row.Quantity }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="WarehouseId" label="预出仓" min-width="120">
              <template slot-scope="{ row, $index }">
                <el-select v-model="row.WarehouseId" @change="changeOutWarehouse($event, row, $index)">
                  <el-option v-for="item in warehouseList" :key="item.WarehouseId" :label="item.WarehouseName" :value="item.WarehouseId"></el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column label="图片" prop="ImgUrl" align="center" min-width="100">
              <template slot-scope="{ row }">
                <el-button type="text" @click="viewImg(row)">{{ row.ProductId ? '查看' : '' }} </el-button>
              </template>
            </el-table-column>
            <el-table-column label="备注" prop="Remark" align="center" min-width="100">
              <template slot-scope="{ row }">
                <span>{{ row.Remark }}</span>
              </template>
            </el-table-column>
            <el-table-column label="存货类型" prop="ProduceTypeName" align="center" min-width="100"> </el-table-column>
            <el-table-column label="子件Bom" prop="ChildBomNo" align="center" min-width="120">
              <template slot-scope="{ row }">
                <child-select
                  v-model="row.ChildBomNo"
                  :source="row.child_arrList"
                  @select="onSelectChild($event, row)"
                  @inputText="inputText"
                  @click.native="resetFun"
                  @currentPage="currentPage"
                  :pageType="false"
                  v-if="Status === 0"
                />
                <span v-else>{{ row.ChildBomNo }}</span>
              </template>
            </el-table-column>
            <el-table-column label="注塑bom版本号" prop="MouldBomNo" align="center" min-width="120">
              <template slot-scope="{ row }">
                <!-- <span  >{{row.BomNo}}</span> -->
                <child-select
                  v-model="row.MouldBomNo"
                  :source="row.MouldBomNos"
                  :Head="[
                    { Value: 'MouldNo', Name: '模具编码', Width: '150' },
                    { Value: 'MouldName', Name: '模具名称', Width: '120' },
                    { Value: 'Bomno', Name: '版本号', Width: '120' }
                  ]"
                  @select="onSelectMouldBomNo($event, row)"
                  :pageType="false"
                  v-if="Status === 0"
                />
                <span v-else>{{ row.MouldBomNo }}</span>
              </template>
            </el-table-column>
            <el-table-column label="损耗率" prop="Loss" align="center" min-width="100">
              <template slot-scope="{ row }">
                <span>{{ row.Loss }}</span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="操作">
              <template slot-scope="{ row, $index }" >
                <el-button type="text" @click.stop="delTableList(row, $index)" v-if="Status === 0">删除 </el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane>
          <div slot="label">工序</div>
          <el-table border key="table3" class="table_bottom table-line tb-c-head" :data="craftData" stripe style="margin-top: 18px" ref="table3">
            <el-table-column prop="ProgrammeName" label="工艺方案名称" min-width="120">
              <template slot-scope="{ row }">
                <el-button type="text" @click="changeProgramme(row)">{{ row.ProgrammeName ? row.ProgrammeName : '选择方案' }} </el-button>
              </template>
            </el-table-column>
            <el-table-column label="方案详情" min-width="120">
              <template slot-scope="{ row }">
                <el-button type="text" @click="changeProgrammeInfo(row)">详情编辑</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>
    </div>

    <list-dialog ref="listDialog" selectable :multiple="false" @select="listDialogSelect"></list-dialog>
    <process-dialog ref="processDialog" @saved="detail_saved"></process-dialog>

    <!-- <edit-dialog ref="editDialog"></edit-dialog> -->
    <img-dialog ref="imgDialog" :imgs="imgs" />
    <bom-img-dialog ref="bomImgDialog" @saved="img_saved" />
  </div>
</template>
  <script>
import accountSelect from '@/components/business/stock/select'
import imgDialog from '@/components/production/craftsmanship/bom/imgDialog'
import bomImgDialog from '@/components/production/craftsmanship/bom/bomImgDialog'
import processDialog from '@/components/production/craftsmanship/combinationbom/processDialog'
import listDialog from '@/components/production/craftsmanship/solutions/fittings/listDialog'
import { urlHttp } from '@/components/production/craftsmanship/bom/bomConfig'
import childSelect from '@/components/business/stock/childSelect'

export default {
  name: 'editcompartsbombom',
  components: {
    accountSelect,
    imgDialog,
    listDialog,
    processDialog,
    childSelect,
    bomImgDialog
  },
  data() {
    return {
      Status: 0,
      viewType: 'create',
      colorApi: require('@/api/ba/color').default,
      propertyApi: require('@/api/ba/property').default,
      warehouseApi: require('@/api/ba/warehouse').default,
      businessTypeApi: require('@/api/ba/businessType').default,
      save2Api: require('@/api/production/teProduct').default,
      tradeUnitApi: require('@/api/ba/tradeUnit').default,
      code_api: require('@/api/sy/serialCode').default,
      api: require('@/api/stock/stInDoc').default,
      pdApi: require('@/api/ba/product').default,
      apiChild: require('@/api/production/teProduct').default,
      teProgrammeApi: require('@/api/production/teProgramme').default,
      teMouldBomApi: require('@/api/production/teMouldBom').default,
      machiningStageApi: require('@/api/ba/machiningStage').default,
      tradeUnitList: [],
      isSave: true,
      MakeEmpName: '',
      ReviewEmpName: '',
      id: 0,
      initDAccount: [],
      initTotal: 0,
      DAccount: [],

      listTotal: 0,
      child_initDAccount: [],
      child_initTotal: 0,
      child_DAccount: [],
      child_listTotal: 0,
      child_arrList: [],
      deleteList: [],
      imgs: [],
      pageParams: {
        pageSize: 7, //分页大小
        pageIndex: 1
      },
      child_pageParams: {
        pageSize: 7, //分页大小
        pageIndex: 1
      },
      craftData: [
        {
          ProgrammeName: '',
          ProgrammeId: 0,
          Processes: []
        }
      ],
      deleteCraftData: [],
      warehouseList: [],
      child: [
        {
          ProductId: 0,
          ProductNo: '',
          ProductName: '',
          ProductSpec: '',
          UnitId: 0,
          UnitName: '',
          Quantity: 1,
          child_arrList: [],
          ChildTeProductId: 0,
          ImgUrl: '',
          ProcessStage: '',
          ProduceTypeName: '',
          ChildBomNo: '',
          Units: [],
          UseColor: true,
          ColorId: 0,
          ColorName: '',
          Colors: [],
          Loss: 0,
          WarehouseId: null,
          MouldBomNo: '',
          MouldBomNos: []
        }
      ],
      tableData: [
        {
          ProductId: 0,
          ProductNo: '',
          ProductName: '',
          ProductSpec: '',
          UnitId: 0,
          UnitName: '',
          Quantity: 1,
          ImgUrl: '',
          ProcessStage: '',
          ProduceTypeName: '',
          BomNo: '',
          ProductionType: 1,
          Yieldrate: 0,
          ProductionDpNo: '',
          ProductionDpId: 0,
          IsDefault: false,
          Units: [],
          UseColor: true,
          WarehouseId: null,
          TeImgs: [],
          TeProductId: 0,
          ColorId:0,
          Colors:[],
        }
      ],
      machiningStageList: [],
      teImgs: [],      
      propertyList: [],
    }
  },
  created() {
    this.init()

    if (this.$route.params.type == 'edit') {
      this.id = this.$route.params.data.TeProductId
      this.editOrder(this.$route.params.data.TeProductId)
    }
    if (this.$route.params.type == 'details') {
      this.editOrder(this.$route.params.data.TeProductId)
    }
    this.warehouseApi.list({ WarehouseType: 1 }).then(res => {
      if (res.Code === 0) {
        this.warehouseList = res.Data
      }
    })
  },
  computed: {
    ReviewName() {
      return this.Status == 2 ? '弃审' : '审核'
    }
  },
  methods: {
    changeProperty(val, row) {
      console.log(val,row,'changeProperty')
      this.setting(row)
        row.PropertyNo = ''
      if (val) {
        var property=this.propertyList.find(x=>x.PropertyId==val);
        if(property){
          row.PropertyNo=property.PropertyNo;
        }
      } 

      if (row.ProductId > 0) {
        row.BarCode = row.ProductNo + '*' + (row.ColorNo || 0) + '*' + (row.PropertyNo || 0)
      }
    },
    changeColor(val,row) {
      console.log(val,row,'changeColor')
      this.setting(row)
      row.ColorNo=""
      if(val){
        var color=row.Colors.find(x=>x.ColorId==val);
        if(color){
          row.ColorNo=color.ColorNo;
        }
      }
      if (row.ProductId > 0) {
        row.BarCode = row.ProductNo + '*' + (row.ColorNo || 0) + '*' + (row.PropertyNo || 0)
      }
    },
    setting(row) {
      if (row.T == null) row.T = 1
      console.log('row', row)
      console.log('this.tableData[0]', this.tableData[0])
    },

    img_saved(data, removeData) {
      console.log(data, removeData, 'img_saved')
      if (data) {
        console.log(data, removeData, 'img_saved2')
        var imgs = []
        data.forEach(item => {
          imgs.push({ TeProductId: this.id, ImgUrl: item.url2, T: item.T, ProductImgId: item.ProductImgId })
        })
        if (removeData.length > 0) {
          removeData.forEach(item => {
            imgs.push({ TeProductId: this.id, ImgUrl: item.url2, T: 2, ProductImgId: item.ProductImgId })
          })
        }
        this.teImgs = imgs
      }
    },
    uploadImg(row) {
      console.log(row, 'row')
      if (this.id > 0) {
        this.$refs.bomImgDialog.openEdit(row)
      } else {
        this.$refs.bomImgDialog.openCreate(row)
      }
    },
    getStage(Stage) {
      const stage = this.machiningStageList.find(stage => stage.MachiningStageId === Stage)
      return stage ? stage.Name : '无'
    },
    changeOutWarehouse(val, row, index) {
      // console.log("val",val,"row",row)
      if (row.T !== 0) {
        row.T = 1
      }
      var obj = { ...row }
      this.child.splice(index, 1, obj)
      //this.$forceUpdate()
    },
    editOrder(data) {
      this.id = data
      this.apiChild.getNewInfo(data).then(res => {
        if (res.Code === 0) {
          this.isSave = false
          this.Status = res.Data.Status
          this.MakeEmpName = res.Data.MakeEmpName
          this.ReviewEmpName = res.Data.ReviewEmpName
          this.tableData[0].TeProductId = res.Data.TeProductId
          this.tableData[0].BomNo = res.Data.Bomno
          this.tableData[0].ProductId = res.Data.ProductId
          this.tableData[0].ProductNo = res.Data.ProductNo
          this.tableData[0].ProductSpec = res.Data.ProductSpec
          this.tableData[0].UnitId = res.Data.UnitId != null ? res.Data.UnitId : 0
          this.tableData[0].UnitName = res.Data.UnitName
          this.tableData[0].ImgUrl = res.Data.ImgUrl
          this.tableData[0].Imgs = res.Data.Imgs
          this.tableData[0].TeImgs = res.Data.TeImgs
          this.tableData[0].Quantity = res.Data.Quantity
          this.tableData[0].ProcessStage = res.Data.ProcessStage
          this.tableData[0].ProductName = res.Data.ProductName
          this.tableData[0].Yieldrate = Number(res.Data.Yieldrate) / 0.01
          this.tableData[0].ProductionDpNo = res.Data.ProductionDpNo
          this.tableData[0].ProductionType = res.Data.ProductionType
          this.tableData[0].IsDefault = res.Data.IsDefault
          this.tableData[0].ProductionDpId = res.Data.ProductionDpId
          this.tableData[0].ProduceTypeName = res.Data.ProduceTypeName
          this.tableData[0].WarehouseId = res.Data.WarehouseId || null
          this.tableData[0].Colors = res.Data.Colors
          this.tableData[0].UseColor = res.Data.UseColor
          this.tableData[0].ColorId = res.Data.ColorId
          this.tableData[0].ColorName = res.Data.ColorName
          this.tableData[0].UseProcess = res.Data.UseProcess
          this.tableData[0].PropertyId=res.Data.PropertyId
          this.tableData[0].PropertyNo=res.Data.PropertyNo
          this.tableData[0].PropertyName=res.Data.PropertyName
          this.tableData[0].BarCode=res.Data.BarCode
          let arr = []
          res.Data.DetailModels.forEach(item => {
            item.T = null
            let isSelectMould = false
            if (item.ProcessStageName === '注塑' && item.ProduceTypeName === '胶件') {
              isSelectMould = true
            }
            let o = {
              ProgrammeName: item.ProgrammeName,
              ProcessSn: item.Sn == null ? item.ProcessSn : item.Sn,
              isSelectMould: isSelectMould,
              isSelectMouldBomno: false,
              ...item,
              Units: item.Units == null ? '' : item.Units,
              Colors: item.Colors == null ? '' : item.Colors
            }
            arr.push(o)
          })
          this.child = arr
          if (this.child.length == 0) {
            this.addList()
          }
          this.child.forEach(item => {
            this.apiChild.list({ ProductId: item.ProductId, pageIndex: 1, pageSize: 7 }).then(res => {
              if (res.Code == 0) {
                item.child_arrList = res.Data
              }
            })
            if (item.MouldId) {
              this.teMouldBomApi
                .list({
                  IsEnable: true,
                  MouldId: item.MouldId
                })
                .then(res => {
                  if (res.Code === 0) {
                    item.MouldBomNos = res.Data
                  }
                })
            }
          })
          let ProcessModels = res.Data.ProcessModels

          if (ProcessModels != null && ProcessModels.length > 0) {
            let arr = []
            ProcessModels.forEach(item => {
              item.T = 1
            })
            let o = {
              ProgrammeName: ProcessModels[0].ProgrammeName,
              ProgrammeId: ProcessModels[0].ProgrammeId,
              Processes: ProcessModels
            }
            arr.push(o)
            this.craftData = arr //ProcessModel
          }
        }
      })
    },
    onSelectMouldBomNo(e, row) {
      row.MouldBomNo = e.Bomno
      if (row.T !== 0) {
        row.T = 1
      }
    },
    changeQuantity(data, row, index) {
      if (row.T == null) row.T = 1
    },
    changeProgramme() {
      this.$refs.listDialog.open()
    },
    changeProgrammeInfo(row) {
      this.$refs.processDialog.open().then(that => {
        that.setTableData(row)
      })
    },
    listDialogSelect(list) {
      console.log('list 方案', list)
      let temps = JSON.parse(JSON.stringify(this.craftData))
      if (temps[0].Processes.length !== 0 && temps[0].Processes[0].T === 1) {
        temps[0].Processes.forEach(item => {
          item.T = 2
        })

        this.deleteCraftData.push(...temps)
      }

      this.craftData[0].ProgrammeId = list.ProgrammeId
      this.craftData[0].ProgrammeName = list.ProgrammeName
      this.craftData[0].Processes = list.Processes
    },
    detail_saved(list) {
      console.log('list', list)
      this.craftData[0].Processes = list
    },
    init() {
      this.tradeUnitApi.list({ TradeUnitTypes: [1, 3], Status: 1 }).then(res => {
        if (res.Code === 0) {
          this.tradeUnitList = res.Data
        }
      })

      this.pdApi
        .list({
          Status: 1,
          pageIndex: 1,
          pageSize: 7
          // ProcessStage: 2
        })
        .then(res => {
          let data = res.Data
          this.DAccount = data
          this.initDAccount = data
          this.listTotal = data.length
          this.initTotal = res.Count
        })

      this.pdApi
        .list({
          Status: 1,
          pageIndex: 1,
          pageSize: 7
          // ProcessStages: [2,1,0]
        })
        .then(res => {
          this.child_DAccount = res.Data
          this.child_initDAccount = res.Data
          this.child_listTotal = res.Count
          this.child_initTotal = res.Count
        })

      this.machiningStageApi.list({}).then(res => {
        this.machiningStageList = res.Data
      })
        this.propertyApi.list({ Status: 1 }).then(res => {
        if (res.Code === 0) {
          this.propertyList = res.Data
        }
      })
    },
    changeProductionDp(val, row) {
      let item = this.tradeUnitList.filter(v => {
        return v.TradeUnitId === val
      })[0]
      row.ProductionDpNo = item.TradeUnitNo
    },
    onSelect(e, row, type = 0) {
      if (type == 1) {
        if (this.tableData[0].ProductId == e.ProductId) return this.$message.warning('请选择与存货不相同的子件存货')
      }
      console.log('e', e)
      row.UnitId = null
      row.UnitName = ''
      row.Units = []
      row.Colors = []
      row.ColorId = 0
      row.ColorName = ''
      row.ColorNo = ''
      row.ProductName = e.ProductName
      row.ProductId = e.ProductId
      row.ProductNo = e.ProductNo
      row.ProductSpec = e.ProductSpec
      row.UseColor = e.UseColor
      row.UseProcess = e.UseProcess
      row.Colors = e.Colors
      row.BarCode = e.ProductNo + '*0*0'
      if (e.Units.length === 0) {
        row.UnitId = e.PdUnitId
        row.UnitName = e.PdUnitName
      } else {
        row.Units = e.Units
      }
      if (type === 0) {
        row.BomNo = e.ProductName
        row.IsDefault = true
      }
      row.Imgs = e.Imgs
      // row.ImgUrl = e.ImgUrl;
      row.ProcessStage = e.ProcessStage
      row.ProduceTypeName = e.ProduceTypeName
      row.WarehouseId = e.DefaultWarehouse
      if (type === 0 && e.HasProgramme) {
        console.log('触发', e.HasProgramme)
        this.teProgrammeApi
          .list({
            ProgrammeType: 1,
            ProductName: row.ProductName,
            IsDefault: true
          })
          .then(res => {
            if (res.Code === 0) {
              if (this.viewType === 'create') {
                let { ProgrammeId, ProgrammeName, Processes } = res.Data[0]
                let o = {
                  ProgrammeName,
                  ProgrammeId,
                  Processes
                }

                let arr = []
                arr.push(o)
                let temps = JSON.parse(JSON.stringify(this.craftData))
                if (temps[0].Processes.length !== 0 && temps[0].Processes[0].T === 1) {
                  temps[0].Processes.forEach(item => {
                    item.T = 2
                  })

                  this.deleteCraftData.push(...temps)
                }
                this.craftData = arr

                console.log('this.craftData', this.craftData)
              }
            }
          })
      }

      if (!e.HasProgramme && type === 0) {
        let temps = JSON.parse(JSON.stringify(this.craftData))
        if (temps[0].Processes.length !== 0 && temps[0].Processes[0].T === 1) {
          temps[0].Processes.forEach(item => {
            item.T = 2
          })

          this.deleteCraftData.push(...temps)
        }
        this.craftData = [
          {
            ProgrammeName: '',
            ProgrammeId: 0,
            Processes: []
          }
        ]
      }
      if (type == 1) {
        if (row.TeProductDetailId > 0) {
          row.T = 1
        } else {
          row.Quantity = 1
        }
        let data = {
          pageIndex: 1,
          pageSize: 10,
          ProductId: row.ProductId
        }
        this.apiChild.list(data).then(res => {
          if (res.Code == 0) {
            row.child_arrList = res.Data
          }
        })

        row.MouldBomNo = ''
        row.MouldBomNos = []

        if (e.ProductType === 2 && e.MouldId != null) {
          let mouldId = e.MouldId
          row.MouldId = mouldId
          this.teMouldBomApi
            .list({
              IsEnable: true,
              mouldId
            })
            .then(res => {
              if (res.Code === 0) {
                row.MouldBomNos = res.Data
              }
            })
        }
      }
    },

    orderReview() {
      console.log(this.id, 'this.id')
      if (this.id == 0) {
        this.$message.warning('信息未保存')
        return
      }
      const message = this.Status == 2 ? '确认要弃审吗？ ' : '确认提交审核吗？'
      this.$confirm(message, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          const data = this.Status == 2 ? 'back' : 'review'
          this.save2Api[data](this.id).then(res => {
            if (res.Code === 0 && data == 'review') {
              this.Status = 2
            }
            if (res.Code === 0 && data == 'back') this.Status = 0
            res.Code === 0 ? this.$message.success(res.Msg) : this.$message.warning(res.Msg)

            if (res.Code === 0) {
              this.editOrder(this.id)
            }
          })
        })
        .catch(() => {})
    },
    base64ToFile(dataurl, filename) {
      //将base64转换为文件
      var arr = dataurl.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new File([u8arr], filename, { type: mime })
    },
    async viewImg(row) {
      const res = await this.pdApi.productImgList(row.ProductId)
      if (res.Code != 0) return this.$message.warning(res.Msg)
      const ImgUrl = res.Data
      if (!ImgUrl || ImgUrl?.length < 1) return this.$message.warning('无图片！')
      let imgs = []
      ImgUrl.forEach(item => {
        // const imgBlob = URL.createObjectURL(this.base64ToFile(item.ImgUrl))
        // imgs.push(imgBlob)
        imgs.push('/api' + item.ImgUrl)
      })
      this.imgs = imgs
      this.$refs.imgDialog.open()
    },

    viewImg2(row) {
      let imgs = []
      row.TeImgs.forEach(item => {
        imgs.push('/api' + item.ImgUrl)
      })

      this.imgs = imgs
      this.$refs.imgDialog.open()
    },
    onSelectChild(e, row) {
      row.ChildBomNo = e.Bomno
      row.ChildTeProductId = e.TeProductId
      // console.log(row.BomNo,' row.BomNo')
    },
    resetFun() {
      this.pageParams.pageIndex = 1
      this.DAccount = this.initDAccount
      this.listTotal = this.initTotal
    },
    currentPage({ val, text1 }) {
      this.pageParams.pageIndex = val
      this.pdApi
        .list({
          pageIndex: val,
          pageSize: 7,
          // ProcessStage: 2,
          Status: 1,
          ProductName: text1
        })
        .then(res => {
          if (res.Code == 0) {
            this.DAccount = res.Data
            this.listTotal = res.Count
          }
        })
    },
    inputText(text) {
      this.pdApi
        .list({
          pageIndex: 1,
          pageSize: 7,
          ProductName: text,
          // ProcessStage: 2,
          Status: 1
        })
        .then(res => {
          if (res.Code == 0) {
            this.DAccount = res.Data

            this.listTotal = res.Count
          }
        })
    },
    inputTextChild(text) {
      this.pdApi
        .list({
          pageIndex: 1,
          pageSize: 7,
          ProductName: text,
          // ProcessStages: [2,1,0],
          Status: 1
        })
        .then(res => {
          if (res.Code == 0) {
            this.child_DAccount = res.Data
            this.child_listTotal = res.Count
          }
        })
    },
    resetChildFun() {
      this.pageParams.pageIndex = 1

      this.child_DAccount = this.initDAccount
      this.child_listTotal = this.initTotal
    },
    currentChildPage({ val, text1 }) {
      this.pageParams.pageIndex = val
      this.pdApi
        .list({
          pageIndex: val,
          pageSize: 7,
          // ProcessStages: [2,1,0],
          Status: 1,
          ProductName: text1
        })
        .then(res => {
          if (res.Code == 0) {
            this.child_DAccount = res.Data
            this.child_listTotal = res.Count
          }
        })
    },
    delTableList(data, index) {
      if (data.T == null) data.T = 2
      if (data.T == 0) data.T = null
      this.deleteList.push(data)
      this.child.splice(index, 1)
      if (this.child.length === 0) this.addList()
    },
    tableRowClassName({ row, rowIndex }) {
      row.index = rowIndex
    },
    addColumn(row, column) {
      if (this.Status == 2) return
      if (column.label === '操作') {
        return
      }
      if (row.index === this.child.length - 1) {
        this.addList()
      }
    },
    addList() {
      this.child.push({
        T: 0,
        ProductId: 0,
        ProductNo: '',
        ProductName: '',
        ProductSpec: '',
        UnitId: 0,
        UnitName: '',
        Quantity: 1,
        child_arrList: [],
        ChildTeProductId: 0,
        ImgUrl: '',
        ProcessStage: '',
        ProduceTypeName: '',
        ChildBomNo: '',
        Units: [],
        UseColor: true,
        ColorId: 0,
        ColorName: '',
        Colors: [],
        Loss: 0,
        WarehouseId: null,
        MouldBomNo: '',
        MouldBomNos: []
      })
    },
    newAdd() {
      Object.assign(this.$data, this.$options.data.call(this))
      this.$route.params.type = 'create'
      this.viewType = 'create'
      this.init()
    },
    save() {
      let data = this.tableData[0]
      // return this.$message.warning("数量不能为空并且不为0");
      if (data.BomNo == '') return this.$message.warning('bom版本号不能为空')
      if (data.ProductId == '') return this.$message.warning('请选择存货')
      if (data.Quantity == 0) return this.$message.warning('需求数量请输入大于0')

      data.BomType = 0
      data.TEBomId = 0
      let child = this.child.filter(item => item.ProductId > 0 && item.T !== null)
      for (let i = 0; i < child.length; i++) {
        if (child[i].Quantity == 0 || child[i].Quantity == '') return this.$message.warning('子件的需求数量不能为0或为空')
      }

      this.deleteList = this.deleteList.filter(item => item.T !== null)
      child = child.concat(this.deleteList)

      data.DetailModels = child
      let arr = []
      let teImgs = this.teImgs.filter(item => item.T !== null)
      this.craftData[0]?.Processes?.forEach(item => {
        let o = {
          T: item.T ?? 0,
          ProgrammeId: item.ProgrammeId,
          ProcessType: item.ProcessType,
          DpId: item.DpId,
          TeProductProcessId: item.TeProductProcessId ?? 0,
          TeProductId: item.TeProductId ?? 0,
          ProcessId: item.ProcessId,
          ProcessSn: item.ProcessSn
        }
        arr.push(o)
      })

      this.deleteCraftData[0]?.Processes?.forEach(item => {
        let o = {
          T: 2,
          ProgrammeId: item.ProgrammeId,
          ProcessType: item.ProcessType,
          DpId: item.DpId ?? 0,
          TeProductProcessId: item.TeProductProcessId,
          TeProductId: item.TeProductId,
          ProcessId: item.ProcessId,
          ProcessSn: item.ProcessSn
        }
        arr.push(o)
      })

      data.ProcessModels = arr
      data.Yieldrate = Number(data.Yieldrate) * 0.01
      data.TeImgs = teImgs
      console.log(data, '保存前数据')
      this.save2Api
        .save2(data)
        .then(res => {
          if (res.Code == 0) {
            this.id = res.Data
            if (res.Data > 0) data.TeProductId = res.Data

            this.$message({ type: 'success', message: res.Msg })
            this.editOrder(data.TeProductId)
          } else {
            this.$message({ type: 'warning', message: res.Msg })
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    reView() {},
    tabClick() {}
  }
}
</script>
  
  <style lang="scss" scoped>
.tabs {
  margin-top: 18px;
}
.text-box {
  display: inline-block;
  margin-left: 18px;
  width: 180px;
}
</style>
  
  
  